<template>
  <div>
    <v-app transition="fade-transition">
      <v-card tile transition="fade-transition">
        <v-container fluid>
          <v-form class="sign-in-form" id="sign-in-form-id" ref="signInForm" v-model="valid" lazy-validation>
            <v-layout wrap justify-center mb-2>
              <v-flex xs12 md7 class="content">
                <v-row class="text-center mb-4">
                  <v-col cols="12">
                    <div class="avatar-logo">
                      <img :src="logoDataUrl" alt="Logo" />
                    </div>
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col cols="12">
                    <p class="default-title font-weight-bold mb-2">Date: {{todayDate()}}</p>
                  </v-col>
                </v-row> -->
                <v-row>
                  <v-col cols="12" sm="12" md="12" lg="12" align="left">
                    <div>
                      <p style="margin: 0px 20px 0px 0px; font-weight: 600">
                        Kobe Global Technologies Pte Ltd.<br />
                        GST Registration no. 201608755R<br />
                        51 Goldhill Plaza<br />
                        #14-01<br />
                        Singapore 308900<br />
                        finance@getkobe.com
                      </p>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12" lg="12" align="left">
                    <div style="border: 1px solid black">
                      <div class="brand-secondary-bg">
                        Content Creator Details
                      </div>
                      <div style="padding: 5px" v-if="displayData.platform === 'tiktok'">
                        TikTok Handle: {{ displayData.handle }}  <br />
                      </div>
                      <div style="padding: 5px" v-else-if="displayData.platform === 'instagram'">
                        Instagram Handle: {{ displayData.handle }}  <br />
                      </div>
                      <div style="padding: 5px" v-else-if="displayData.platform === 'youtube'">
                        Youtube Handle: {{ displayData.handle }}  <br />
                      </div>
                      <div style="padding: 5px" v-else-if="displayData.platform === 'twitter'">
                        X (Twitter) Handle: {{ displayData.handle }}  <br />
                      </div>
                      <div style="padding: 5px" v-else-if="displayData.platform === 'others'">
                        {{ displayData.platformName | platformDisplayName }} Handle: {{ displayData.handle }}  <br />
                      </div>
                      <div style="padding: 5px" v-else>
                        Platform Handle: {{ displayData.handle }}  <br />
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12" lg="12" align="left">
                    <div style="border: 1px solid black">
                      <div class="brand-secondary-bg">Company Rep Details</div>
                      <div style="padding: 5px">
                        <strong>Kobe Global Technologies Pte Ltd.</strong> <br />
                        (+65) 6255 5662 <br />
                        finance@getkobe.com
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12" lg="12" align="left">
                    <div style="border: 1px solid black">
                      <div class="brand-secondary-bg">Campaign Details</div>
                      <div style="padding: 5px">
                        <strong>{{ displayData.campaignName }}</strong> <br />
                        <!-- Campaign Period: {{ dateFormat(contract.brief.startDate) }} - {{ dateFormat(contract.brief.endDate) }} <br /> -->
                        Campaign Ref: {{displayData.campaignID}}
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row v-if="pairingDetails.deliverables_details">
                  <v-col cols="12" sm="12" md="12" lg="12" align="left">
                    <div >
                      <table style="width: 100%; border-top: 1px solid black;">
                        <thead class="brand-secondary-bg">
                          <tr style="border-left:1px solid black;">
                            <td style="text-align: center">DESCRIPTION</td>
                            <td style="text-align: center">QTY</td>
                            <td style="text-align: center">AMOUNT</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="pairingDetails.deliverables_details.no_of_stories" style="border-left:1px solid black;">
                            <td>IG Story</td>
                            <td style="text-align: center">{{pairingDetails.deliverables_details.no_of_stories}}</td>
                            <td style="text-align: center" :rowspan="getRowSpanCount" v-if="checkShowAmountRowSpan('no_of_stories')">{{formatPayout(chkPayoutGST)}}</td>
                          </tr>
                          <tr v-if="pairingDetails.deliverables_details.no_of_xhs_posts" style="border-left:1px solid black;">
                            <td>XHS Post</td>
                            <td style="text-align: center">{{pairingDetails.deliverables_details.no_of_xhs_posts}}</td>
                            <td style="text-align: center" :rowspan="getRowSpanCount" v-if="checkShowAmountRowSpan('no_of_xhs_posts')">{{formatPayout(chkPayoutGST)}}</td>
                          </tr>
                          <tr v-if="pairingDetails.deliverables_details.no_of_tiktok_posts" style="border-left:1px solid black;">
                            <td>TikTok Post</td>
                            <td style="text-align: center">{{pairingDetails.deliverables_details.no_of_tiktok_posts}}</td>
                            <td style="text-align: center" :rowspan="getRowSpanCount" v-if="checkShowAmountRowSpan('no_of_tiktok_posts')">{{formatPayout(chkPayoutGST)}}</td>
                          </tr>
                          <tr v-if="pairingDetails.deliverables_details.no_of_posts" style="border-left:1px solid black;">
                            <td>IG Post</td>
                            <td style="text-align: center">{{pairingDetails.deliverables_details.no_of_posts}}</td>
                            <td v-if="checkShowAmountRowSpan('no_of_posts')" style="text-align: center" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                          </tr>
                          <tr v-if="pairingDetails.deliverables_details.no_of_carousels" style="border-left:1px solid black;">
                            <td>IG Carousel</td>
                            <td style="text-align: center">{{pairingDetails.deliverables_details.no_of_carousels}}</td>
                            <td v-if="checkShowAmountRowSpan('no_of_carousels')" style="text-align: center" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                          </tr>
                          <tr v-if="pairingDetails.deliverables_details.no_of_video" style="border-left:1px solid black;">
                            <td>IG Video</td>
                            <td style="text-align: center">{{pairingDetails.deliverables_details.no_of_video}}</td>
                            <td v-if="checkShowAmountRowSpan('no_of_video')" style="text-align: center;" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                          </tr>
                          <tr v-if="pairingDetails.deliverables_details.no_of_igTv" style="border-left:1px solid black;">
                            <td>IG TV</td>
                            <td style="text-align: center">{{pairingDetails.deliverables_details.no_of_igTv}}</td>
                            <td v-if="checkShowAmountRowSpan('no_of_igTv')" style="text-align: center" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                          </tr>
                          <tr v-if="pairingDetails.deliverables_details.no_of_reels" style="border-left:1px solid black;">
                            <td>IG Reels</td>
                            <td style="text-align: center">{{pairingDetails.deliverables_details.no_of_reels}}</td>
                            <td style="text-align: center" v-if="checkShowAmountRowSpan('no_of_reels')" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                          </tr>
                          <tr v-if="pairingDetails.deliverables_details.no_of_li_posts" style="border-left:1px solid black;">
                            <td>LinkedIn Post</td>
                            <td style="text-align: center">{{pairingDetails.deliverables_details.no_of_li_posts}}</td>
                            <td style="text-align: center" v-if="checkShowAmountRowSpan('no_of_li_posts')" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                          </tr>
                          <tr v-if="pairingDetails.deliverables_details.no_of_x_posts" style="border-left:1px solid black;">
                            <td>X (Twitter) Post</td>
                            <td style="text-align: center">{{pairingDetails.deliverables_details.no_of_x_posts}}</td>
                            <td style="text-align: center" v-if="checkShowAmountRowSpan('no_of_x_posts')" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                          </tr>
                          <tr v-if="pairingDetails.deliverables_details.youtube" style="border-left:1px solid black;">
                            <td>Youtube</td>
                            <td style="text-align: center">{{pairingDetails.deliverables_details.youtube}}</td>
                            <td style="text-align: center" v-if="checkShowAmountRowSpan('youtube')" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                          </tr>
                          <tr v-if="pairingDetails.deliverables_details.loading_whitelisting" style="border-left:1px solid black;">
                            <td>Loading/Whitelisting</td>
                            <td style="text-align: center">{{pairingDetails.deliverables_details.loading_whitelisting}}</td>
                            <td style="text-align: center" v-if="checkShowAmountRowSpan('loading_whitelisting')" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                          </tr>
                          <tr v-if="pairingDetails.deliverables_details.exclusivity" style="border-left:1px solid black;">
                            <td>Exclusivity </td>
                            <td style="text-align: center">{{pairingDetails.deliverables_details.exclusivity}}</td>
                            <td style="text-align: center" v-if="checkShowAmountRowSpan('exclusivity')" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                          </tr>
                          <tr v-if="pairingDetails.deliverables_details.physical_attendance" style="border-left:1px solid black;">
                            <td>Physical Attendance </td>
                            <td style="text-align: center">{{pairingDetails.deliverables_details.physical_attendance}}hrs</td>
                            <td style="text-align: center" v-if="checkShowAmountRowSpan('physical_attendance')" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                          </tr>
                          <tr v-if="pairingDetails.deliverables_details.online_attendance" style="border-left:1px solid black;">
                            <td>Online Attendance </td>
                            <td style="text-align: center">{{pairingDetails.deliverables_details.online_attendance}}hrs</td>
                            <td style="text-align: center" v-if="checkShowAmountRowSpan('online_attendance')" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                          </tr>
                          <tr v-if="pairingDetails.deliverables_details.no_of_fb_posts" style="border-left:1px solid black;">
                            <td>Facebook </td>
                            <td style="text-align: center">{{pairingDetails.deliverables_details.no_of_fb_posts}}</td>
                            <td style="text-align: center" v-if="checkShowAmountRowSpan('no_of_fb_posts')" :rowspan="getRowSpanCount">{{formatPayout(chkPayoutGST)}}</td>
                          </tr>
                          <tr
                          v-for="(custom, index) in pairingDetails.deliverables_details.custom"
                          :key="index"
                          style="border-left:1px solid black;">
                            <td>{{custom.label}}</td>
                            <td style="text-align: center">{{custom.value}}</td>
                            <td style="text-align: center" :rowspan="getRowSpanCount" v-if="index === 0 && checkShowAmountRowSpan('custom')">{{formatPayout(chkPayoutGST)}}</td>
                          </tr>
                          <tr
                          v-if="pairingDetails.payout_details"
                          v-for="(boostingFee, index) in pairingDetails.payout_details.boostingFees"
                          :key="index"
                          style="border-left:1px solid black;">
                            <td colspan="2">{{boostingFee.label}}</td>
                            <td style="text-align: center">{{formatPayout(boostingFee.value)}}</td>
                          </tr>
                          <tr v-if="pairingDetails.payout_details.GSTpercent" style="border-left:1px solid black;">
                            <td>
                              GST
                            </td>
                            <td style="text-align: center">1</td>
                            <td style="text-align: center" >{{formatPayout(pairingDetails.payout_details.GSTpercent)}}</td>
                          </tr>
                          <tr v-if="pairingDetails.pairing_details.deliverable_notes" style="border-left:1px solid black;">
                            <td colspan="3">
                              <p v-html="formatDesc(pairingDetails.pairing_details.deliverable_notes)"></p>
                            </td>
                          </tr>
                          <tr>
                            <td style="border:none !important;"></td>
                            <td colspan="3" class="brand-secondary-total-cell">
                              <strong> TOTAL: {{formatPayout(pairingDetails.payout_details.amount)}} </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </v-col>
                </v-row>
                <v-row v-if="pairingDetails.remarks">
                  <v-col cols="12" sm="12" md="12" lg="12" align="left">
                    <span v-html="pairingDetails.remarks"></span>
                  </v-col>
                </v-row>
                <v-row v-if="pairingDetails.pairing_details && pairingDetails.pairing_details.remarks">
                  <v-col cols="12" sm="12" md="12" lg="12" align="left">
                    <div style="border: 1px solid black">
                      <div class="brand-secondary-bg">Remarks</div>
                      <div style="padding: 5px" v-html="formatDesc(pairingDetails.pairing_details.remarks)">
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12" lg="12" align="left">
                    <div>
                      <h2>Terms and Conditions</h2>
                      <ol>
                        <li>I have read and accepted the terms of use (<a href="https://www.getkobe.com/influencer-terms-use-agreement/" target="_blank">https://www.getkobe.com/influencer-terms-use-agreement/</a>).</li>
                        <li>I have read and understood supporting campaign details that accompany this brief.</li>
                        <li>I will not liaise with the Brand or the PR company, production company or any other agency involved in this campaign directly without consulting Kobe Global Technologies Pte Ltd for the duration of this campaign, and for the three months directly following job completion. If the Brand contacts me in this period for this campaign, I am under obligation to refer the client to Kobe Global Technologies Pte Ltd.</li>
                        <li>I understand that the rate for this campaign is agreed upon before the commencement of the job and cannot be negotiated in any terms once the job is completed.</li>
                        <li>I understand that the campaign brief and requirements may change and I am to provide updated availability and/or rates as required.</li>
                        <li>Once I have received confirmation of the brief, I will submit all drafts in a timely manner and according to the requested guidelines from the client. I will ensure the post goes live by the date of deadline and and understand if this is not met, or the client has any complaints about my performance,
                          I may forfeit my rate or be deducted a penalty by the client.</li>
                        <li>I agree that any content submitted to Kobe pursuant to a Campaign Agreement and accepted by a Client shall remain publicly accessible through your social media account(s) for a minimum of six (6) months, or such greater term as specified in the Campaign Agreement.</li>
                        <li>I own all of the content and information i create, in addition, the content that is covered by intellectual property rights, like photos and videos (IP content), You hereby represent and warrant that the content will be an original work of you and that the content will not infringe or misappropriate the intellectual property rights of any third party.</li>
                        <li>I will submit my payout and all post statistics on https://app.getkobe.com/ once job has been completed in order for payment to be processed. Payment will be received within 45 days after payout submission on the platform and/or payment clearance from client, whichever earlier.</li>
                        <li>If products are incorporated within the campaign, they should not be included for the purpose of sale or resale.</li>
                        <li>The client is legally obligated to provide appropriate and conspicuous credit to the original creators whenever content is shared on their social media platforms. The client agrees that any actions involving boosting, paid promotion, or similar techniques for content amplification will only be undertaken with prior consent from the relevant parties.</li>
                      </ol>
                    </div>
                  </v-col>
                </v-row>
                <!-- <terms-and-conditions /> -->
                <v-row>
                  <v-col cols="12">
                    <v-col xs="12" md="6" v-if="pairingDetails.pairing_details">
                      <h4>Please confirm your submission date!</h4>
                      {{ formatSubmissionDate(pairingDetails.pairing_details.submission_date) }}
                      <v-btn
                        @click="openUpdateSubmissionDialog(pairingDetails)"
                        color="secondary"
                        v-bind="attrs"
                        v-on="on"
                        small
                        text
                      >
                        <v-icon color="secondary" small>edit</v-icon> <span>Update Date</span>
                      </v-btn>  
                    </v-col>
                    <v-col xs="12" md="6">
                      <div class="text-right" style="max-width:420px">
                        <v-btn
                          small
                          class="mx-0 mb-2"
                          color="secondary"
                          @click="clearSignature"
                        >Clear</v-btn>
                        <div style="border: 1px solid #cfcece;margin-bottom: 10px;max-width: 100%;overflow: hidden;">
                          <canvas id="signin-signature-pad" class="cls-signature-pad" width=400 height=200></canvas>
                        </div>
                      </div>
                      <p class="text-danger" style="font-weight:500" v-if="errors.signature">Signature field is required.</p>
                      <p class="default-title mb-2">Signature</p>
                      <p class="default-title mb-2">Date: {{todayDate()}}</p>
                    </v-col>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-btn :disabled="submitting" class="secondary" x-large @click.prevent="submitForm">
                      <i class="fa fa-circle-o-notch fa-spin" v-if="submitting"></i>
                      Submit
                    </v-btn>
                  </v-col>
                </v-row>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card>
      <!-- Update Creator Email Modal -->
      <update-submission-date-modal
      v-model="updateSubmissionDateDialog"
      :value="updateSubmissionDateDialog"
      :pairing="viewPairingData"
      @updated="refreshPairing"
      @closeModal="closeSubmissionDialog" />
    </v-app>
  </div>
</template>
<script>
import SignaturePad from 'signature_pad';
import { mapState } from 'vuex'
import campaignAPIs from '../../Campaign/campaignAPIs'
import moment from 'moment';
import utils from '@/utils';
import TermsAndConditions from './TermsAndConditions'
import influencerContractTemplate from '../../Contract/Influencer_contract'
import UpdateSubmissionDateModal from '../../Campaign/PairingInfluencer/UpdateSubmissionDateModal'
import logoDataURL from '@/config/logoDataURL'
// import HTMLToPDF from '@/components/editor/generator/HTMLToPDF'
// import BlocksToHtml from '@/components/editor/generator/blocksToHtml'
import * as pdfMake from 'pdfmake/build/pdfmake.js';
// import * as pdfFonts from '../../Campaign/custom-fonts';
// const vfs = pdfFonts.pdfMake.vfs;
// setTimeout(() => {
//   pdfMake.vfs = vfs
// }, 100)
export default {
  name: 'CreateSigningForm',
  components: {
    TermsAndConditions,
    UpdateSubmissionDateModal
  },
  data () {
    return {
      utils: utils.func,
      campaign: {},
      displayData: {},
      logoDataUrl: logoDataURL.logo || '/static/img/kobe_bg_main.png',
      valid: true,
      signaturePad: null,
      errors: {
        signature: false
      },
      submitting: false,
      showRowSpan: '',
      viewPairingData: null
    }
  },
  computed: {
    ...mapState({
      saved: state => state.pairing.saved,
      pairingDetails: state => state.pairing.pairingDetails
    }),
    secondaryColor() {
      return this.$vuetify && this.$vuetify.theme && this.$vuetify.theme.currentTheme && this.$vuetify.theme.currentTheme.secondary
        ? this.$vuetify.theme.currentTheme.secondary
        : '#3F3FFF'
    },
    getRowSpanCount() {
      this.rowSpanCount = 0
      if (this.pairingDetails.deliverables_details.no_of_carousels > 0) this.rowSpanCount++
      if (this.pairingDetails.deliverables_details.no_of_igTv > 0) this.rowSpanCount++
      if (this.pairingDetails.deliverables_details.no_of_tiktok_posts > 0) this.rowSpanCount++
      if (this.pairingDetails.deliverables_details.no_of_xhs_posts > 0) this.rowSpanCount++
      if (this.pairingDetails.deliverables_details.no_of_fb_posts > 0) this.rowSpanCount++
      if (this.pairingDetails.deliverables_details.no_of_posts > 0) this.rowSpanCount++
      if (this.pairingDetails.deliverables_details.no_of_stories > 0) this.rowSpanCount++
      if (this.pairingDetails.deliverables_details.no_of_video > 0) this.rowSpanCount++
      if (this.pairingDetails.deliverables_details.no_of_reels > 0) this.rowSpanCount++
      if (this.pairingDetails.deliverables_details.no_of_li_posts > 0) this.rowSpanCount++
      if (this.pairingDetails.deliverables_details.no_of_x_posts > 0) this.rowSpanCount++
      if (this.pairingDetails.deliverables_details.youtube > 0) this.rowSpanCount++
      if (this.pairingDetails.deliverables_details.loading_whitelisting) this.rowSpanCount++
      if (this.pairingDetails.deliverables_details.exclusivity) this.rowSpanCount++
      if (this.pairingDetails.deliverables_details.physical_attendance) this.rowSpanCount++
      if (this.pairingDetails.deliverables_details.online_attendance) this.rowSpanCount++
      if (this.pairingDetails.deliverables_details.custom) this.rowSpanCount += this.pairingDetails.deliverables_details.custom.length
      return this.rowSpanCount;
    },
    chkPayoutGST() {
      let payout = this.pairingDetails.payout_details.amount;
      // Reduce boosting fees from payout
      if (this.pairingDetails.payout_details && this.pairingDetails.payout_details.boostingFees && Array.isArray(this.pairingDetails.payout_details.boostingFees)) {
        for (let boostingFee of this.pairingDetails.payout_details.boostingFees) {
          payout -= Number(boostingFee.value) || 0;
        }
      }
      if (this.pairingDetails.payout_details.GST) {
        return payout - this.pairingDetails.payout_details.GSTpercent
      } else {
        return payout
      }
    }
  },
  methods: {
    submitForm() {
      this.resetError()
      if (this.signaturePad.isEmpty()) {
        this.errors.signature = true
      }
      if (!this.pairingDetails.pairing_details.submission_date) {
        this.$swal({
          text: 'Please update submission date.',
          type: 'info'
        });
        return
      }
      // init form submit
      // console.log(JSON.stringify(this.signaturePad.toData()))
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.submitting = true
          // const saveData = Object.assign({}, {
          //   pairingID: this.pairingDetails.id,
          //   signature: this.signaturePad.toData()
          // });
          let contractFileBlocks = await this.generateContract()
          let pdfDocGenerator = pdfMake.createPdf(utils.func.refreshJSON(contractFileBlocks))
          let contractFile = await new Promise((resolve) => {
            pdfDocGenerator.getDataUrl((dataUrl) => {
              let response = utils.func.dataURLtoFile(dataUrl, `${this.pairingDetails.influencer_details.instagramHandle}_Signin_Form.pdf`)
              resolve(response)
            })
          })
          let formData = new FormData();
          formData.append('pairingID', this.pairingDetails.id)
          formData.append('signature', JSON.stringify(this.signaturePad.toData()))
          formData.append('contractFileBlocks', JSON.stringify(contractFileBlocks))
          formData.append('contractFile', contractFile)
          await this.$store.dispatch('pairing/saveSignInForm', formData)
          this.submitting = false
          if (this.saved) {
            // Show success message
            this.$swal({
              text: 'Successfully Saved Sign in Form.',
              type: 'success'
            }).then(result => {
              window.location.replace('/')
            })
          } else {
            this.$swal({
              text: 'Error Saving Sign in Form.',
              type: 'error'
            });
          }
        }
      });
    },
    clearSignature() {
      this.signaturePad.clear()
    },
    resetError() {
      this.errors = {
        signature: false
      }
    },
    todayDate() {
      return this.utils.formatCustomDate(moment(), 'DD/MM/YYYY')
    },
    async generateContract() {
      let tableBody = [];
      let contractTemplate = utils.func.refreshJSON(influencerContractTemplate)
      // Header Date
      contractTemplate.header.text = 'Date: ' + this.dateFormat(Date.now());
      contractTemplate.defaultStyle = {font: 'Arial'};
      // Content Creator Details
      if (this.pairingDetails.influencer_details.platform === 'tiktok') {
        contractTemplate.content[2].table.body[1][0].text = 'TikTok Handle: ' + this.pairingDetails.influencer_details.instagramHandle
      } else if (this.pairingDetails.influencer_details.platform === 'instagram') {
        contractTemplate.content[2].table.body[1][0].text = 'Instagram Handle: ' + this.pairingDetails.influencer_details.instagramHandle
      } else if (this.pairingDetails.influencer_details.platform === 'youtube') {
        contractTemplate.content[2].table.body[1][0].text = 'Youtube Handle: ' + this.pairingDetails.influencer_details.instagramHandle
      } else if (this.pairingDetails.influencer_details.platform === 'xiaohongshu') {
        contractTemplate.content[2].table.body[1][0].text = 'Xiaohongshu Handle: ' + this.pairingDetails.influencer_details.fullName
      } else if (this.pairingDetails.influencer_details.platform === 'twitter') {
        const xHandle = this.pairingDetails.influencer_details.twitterHandle || this.pairingDetails.influencer_details.userHandle || this.pairingDetails.influencer_details.instagramHandle
        contractTemplate.content[2].table.body[1][0].text = 'X (Twitter) Handle: ' + xHandle
      } else if (this.pairingDetails.influencer_details.platform === 'others') {
        contractTemplate.content[2].table.body[1][0].text = this.pairingDetails.influencer_details.platformName + ' Handle: ' + this.pairingDetails.influencer_details.fullName
      } else {
        contractTemplate.content[2].table.body[1][0].text = 'Platform Handle: ' + this.pairingDetails.influencer_details.instagramHandle
      }
      // contractTemplate.content[2].table.body[2][0].text = 'Full Name: ' + (this.pairingDetails.influencer_details.fullname || '-');
      // Campaign Details
      contractTemplate.content[4].table.body[1][0].text = this.displayData.campaignName;
      // contractTemplate.content[4].table.body[2][0].text = `Campaign Period: ${this.dateFormat(this.pairingDetails.brief.startDate)} - ${this.dateFormat(this.pairingDetails.brief.endDate)}`;
      contractTemplate.content[4].table.body[2][0].text = 'Campaign Ref: ' + this.pairingDetails.campaignID;
      // DELIVERABLES
      tableBody.push([{text: 'DESCRIPTION', style: 'tableHeader', alignment: 'center'}, {text: 'QTY', style: 'tableHeader', alignment: 'center'}, {text: 'AMOUNT', style: 'tableHeader', alignment: 'center'}]);
      if (this.pairingDetails.deliverables_details) {
        if (this.pairingDetails.deliverables_details.no_of_stories) {
          tableBody.push(['IG Story', {text: this.pairingDetails.deliverables_details.no_of_stories, alignment: 'center'},
          // {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center'},
          (this.checkShowAmountRowSpan('no_of_stories') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
          ]);
        }
        if (this.pairingDetails.deliverables_details.no_of_xhs_posts) {
          tableBody.push(['XHS Post', {text: this.pairingDetails.deliverables_details.no_of_xhs_posts, alignment: 'center'},
          // {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center'},
          (this.checkShowAmountRowSpan('no_of_xhs_posts') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
          ]);
        }
        if (this.pairingDetails.deliverables_details.no_of_fb_posts) {
          tableBody.push(['FB Post', {text: this.pairingDetails.deliverables_details.no_of_fb_posts, alignment: 'center'},
          // {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center'},
          (this.checkShowAmountRowSpan('no_of_fb_posts') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
          ]);
        }
        if (this.pairingDetails.deliverables_details.no_of_tiktok_posts) {
          tableBody.push(['TikTok Post', {text: this.pairingDetails.deliverables_details.no_of_tiktok_posts, alignment: 'center'},
          // (!this.pairingDetails.deliverables_details.no_of_tiktok_posts ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
          (this.checkShowAmountRowSpan('no_of_tiktok_posts') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
          ]);
        }
        if (this.pairingDetails.deliverables_details.no_of_posts) {
          tableBody.push(['IG Post', {text: this.pairingDetails.deliverables_details.no_of_posts, alignment: 'center'},
          // (!this.pairingDetails.deliverables_details.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
          (this.checkShowAmountRowSpan('no_of_posts') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
          ]);
        }
        if (this.pairingDetails.deliverables_details.no_of_carousels) {
          tableBody.push(['IG Carousel', {text: this.pairingDetails.deliverables_details.no_of_carousels, alignment: 'center'},
          // (!this.pairingDetails.deliverables_details.no_of_posts && !this.pairingDetails.deliverables_details.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
          (this.checkShowAmountRowSpan('no_of_carousels') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
          ]);
        }
        if (this.pairingDetails.deliverables_details.no_of_video > 0) {
          tableBody.push(['IG Video', {text: this.pairingDetails.deliverables_details.no_of_video, alignment: 'center'},
          // (!this.pairingDetails.deliverables_details.no_of_carousels && !this.pairingDetails.deliverables_details.no_of_posts && !this.pairingDetails.deliverables_details.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
          (this.checkShowAmountRowSpan('no_of_video') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
          ]);
        }
        if (this.pairingDetails.deliverables_details.no_of_igTv > 0) {
          tableBody.push(['IG TV', {text: this.pairingDetails.deliverables_details.no_of_igTv, alignment: 'center'},
          // (!this.pairingDetails.deliverables_details.no_of_video && !this.pairingDetails.deliverables_details.no_of_carousels && !this.pairingDetails.deliverables_details.no_of_posts && !this.pairingDetails.deliverables_details.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
          (this.checkShowAmountRowSpan('no_of_igTv') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
          ]);
        }
        if (this.pairingDetails.deliverables_details.no_of_reels > 0) {
          tableBody.push(['IG Reel', {text: this.pairingDetails.deliverables_details.no_of_reels, alignment: 'center'},
          // (!this.pairingDetails.deliverables_details.no_of_video && !this.pairingDetails.deliverables_details.no_of_carousels && !this.pairingDetails.deliverables_details.no_of_posts && !this.pairingDetails.deliverables_details.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
          (this.checkShowAmountRowSpan('no_of_reels') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
          ]);
        }
        if (this.pairingDetails.deliverables_details.no_of_li_posts > 0) {
          tableBody.push(['LinkedIn Post', {text: this.pairingDetails.deliverables_details.no_of_li_posts, alignment: 'center'},
          // (!this.pairingDetails.deliverables_details.no_of_video && !this.pairingDetails.deliverables_details.no_of_carousels && !this.pairingDetails.deliverables_details.no_of_posts && !this.pairingDetails.deliverables_details.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
          (this.checkShowAmountRowSpan('no_of_li_posts') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
          ]);
        }
        if (this.pairingDetails.deliverables_details.no_of_x_posts > 0) {
          tableBody.push(['X (Twitter) Post', {text: this.pairingDetails.deliverables_details.no_of_x_posts, alignment: 'center'},
          (this.checkShowAmountRowSpan('no_of_x_posts') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
          ]);
        }
        if (this.pairingDetails.deliverables_details.youtube > 0) {
          tableBody.push(['Youtube', {text: this.pairingDetails.deliverables_details.youtube, alignment: 'center'},
          // (!this.pairingDetails.deliverables_details.no_of_video && !this.pairingDetails.deliverables_details.no_of_carousels && !this.pairingDetails.deliverables_details.no_of_posts && !this.pairingDetails.deliverables_details.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
          (this.checkShowAmountRowSpan('youtube') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
          ]);
        }
        if (this.pairingDetails.deliverables_details.loading_whitelisting) {
          tableBody.push(['Loading/Whitelisting', {text: this.pairingDetails.deliverables_details.loading_whitelisting, alignment: 'center'},
          // (!this.pairingDetails.deliverables_details.no_of_video && !this.pairingDetails.deliverables_details.no_of_carousels && !this.pairingDetails.deliverables_details.no_of_posts && !this.pairingDetails.deliverables_details.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
          (this.checkShowAmountRowSpan('loading_whitelisting') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
          ]);
        }
        if (this.pairingDetails.deliverables_details.exclusivity) {
          tableBody.push(['Exclusivity', {text: this.pairingDetails.deliverables_details.exclusivity, alignment: 'center'},
          // (!this.pairingDetails.deliverables_details.no_of_video && !this.pairingDetails.deliverables_details.no_of_carousels && !this.pairingDetails.deliverables_details.no_of_posts && !this.pairingDetails.deliverables_details.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
          (this.checkShowAmountRowSpan('exclusivity') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
          ]);
        }
        if (this.pairingDetails.deliverables_details.physical_attendance > 0) {
          tableBody.push(['Physical Attendance', {text: this.pairingDetails.deliverables_details.physical_attendance, alignment: 'center'},
          // (!this.pairingDetails.deliverables_details.no_of_video && !this.pairingDetails.deliverables_details.no_of_carousels && !this.pairingDetails.deliverables_details.no_of_posts && !this.pairingDetails.deliverables_details.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
          (this.checkShowAmountRowSpan('physical_attendance') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
          ]);
        }
        if (this.pairingDetails.deliverables_details.online_attendance > 0) {
          tableBody.push(['Online Attendance', {text: this.pairingDetails.deliverables_details.online_attendance, alignment: 'center'},
          // (!this.pairingDetails.deliverables_details.no_of_video && !this.pairingDetails.deliverables_details.no_of_carousels && !this.pairingDetails.deliverables_details.no_of_posts && !this.pairingDetails.deliverables_details.no_of_stories ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : ''),
          (this.checkShowAmountRowSpan('online_attendance') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')
          ]);
        }
        if (this.pairingDetails.deliverables_details.custom && this.pairingDetails.deliverables_details.custom.length > 0) {
          let customDeliverables = this.pairingDetails.deliverables_details.custom
          for (const [index, obj] of customDeliverables.entries()) {
            console.log(index)
            tableBody.push([obj.label, {text: obj.value, alignment: 'center'},
            (this.checkShowAmountRowSpan('custom') ? {rowSpan: this.getRowSpanCount, text: this.formatPayout(this.chkPayoutGST), alignment: 'center', margin: 10} : '')]);
          }
        }
      }
      if (this.pairingDetails.GST) {
        tableBody.push(['GST', {text: 1, alignment: 'center'},
        // {rowSpan: 1, text: this.formatPayout(this.pairingDetails.GSTpercent), alignment: 'center', margin: 10},
        {rowSpan: 1, text: this.formatPayout(this.pairingDetails.GSTpercent), alignment: 'center', margin: 10}])
      }
      if (this.pairingDetails.deliverableNotes) {
        tableBody.push([{colSpan: 3, text: this.pairingDetails.deliverableNotes, alignment: 'left'}])
      }
      if (this.pairingDetails.pairing_details) {
        if (this.pairingDetails.pairing_details.deliverable_notes) {
          tableBody.push([{colSpan: 3, text: this.pairingDetails.pairing_details.deliverable_notes, alignment: 'left'}])
        }
      }
      tableBody.push([{border: [false, true, false, false], text: ''}, {fillColor: this.secondaryColor, color: 'white', colSpan: 2, rowSpan: 1, text: `TOTAL: ${this.formatPayout(this.pairingDetails.payout_details.amount || 0)}`, alignment: 'center'}]);
      contractTemplate.content[5].table.body = tableBody;
      if (this.pairingDetails.pairing_details && this.pairingDetails.pairing_details.remarks) {
        contractTemplate.content.splice(6, 0, {
          margin: [0, 20, 0, 0],
          table: {
            widths: ['100%'],
            body: [
              [{text: 'Remarks', style: 'tableHeader', alignment: 'left'}],
              [{text: this.pairingDetails.pairing_details.remarks, border: [true, true, true, true]}]
            ]
          }
        })
      }
      contractTemplate.content.push({
        text: '',
        margin: [0, 20, 0, 0]
      })
      contractTemplate.content.push({
        // if you specify both width and height - image will be stretched
        image: this.signaturePad.toDataURL(),
        width: 200,
        height: 200,
        alignment: 'right'
      })
      contractTemplate.content.push({
        text: 'Signature',
        fontSize: '12',
        alignment: 'right',
        margin: [0, 0, 10, 0]
      })
      contractTemplate.content.push({
        text: 'Date: ' + this.dateFormat(Date.now()),
        fontSize: '12',
        alignment: 'right',
        margin: [0, 5, 10, 0]
      })
      // let pdfDocGenerator = pdfMake.createPdf(contractTemplate)
      // let contractFile = await new Promise((resolve) => {
      //   pdfDocGenerator.getDataUrl((dataUrl) => {
      //     let response = utils.func.dataURLtoFile(dataUrl, 'signin_form.pdf')
      //     resolve(response)
      //   })
      // })
      return contractTemplate
      // let briefPdfData = null
      // let blocks = await this.generateBlocks()
      // let blocksTohtml = new BlocksToHtml(blocks)
      // this.briefDetailContent = blocksTohtml.generate(false)
      // const htmlToPdf = new HTMLToPDF(this.briefDetailContent, 'Barlow')
      // briefPdfData = await htmlToPdf.generate()
    },
    dateFormat(date) {
      return moment(date).format('DD/MM/yyyy')
    },
    checkShowAmountRowSpan(type) {
      if (!this.showRowSpan) {
        this.showRowSpan = type
        return true
      } else if (this.showRowSpan === type) return true
      return false
    },
    formatPayout(n) {
      let currency = 'SGD'
      if (this.pairingDetails.payout_details) {
        currency = this.pairingDetails.payout_details.currency || 'SGD'
      }
      if (n === null || n === undefined || n === '') return n
      const formatAmount = value => {
        const amount = Number(value)
        return isNaN(amount) ? value : amount.toFixed(2)
      }
      if (n.toString().indexOf('-') !== -1) {
        let str = n.toString().split('-')
        return currency + ' ' + formatAmount(str[0]) + ' - ' + formatAmount(str[1])
      } else {
        return currency + ' ' + formatAmount(n)
      }
    },
    formatDesc(text) {
      return text.replaceAll('\n', '</br>')
    },
    formatSubmissionDate(date) {
      return date ? moment(date).format('DD/MM/yyyy') : ''
    },
    openUpdateSubmissionDialog(item) {
      this.viewPairingData = Object.assign({}, item)
      this.updateSubmissionDateDialog = true
    },
    refreshPairing() {
      if (this.$route.params.pairingID) {
        this.$store.dispatch('pairing/getPairingDetails', this.$route.params.pairingID)
      }
    },
    closeSubmissionDialog() {
      this.updateSubmissionDateDialog = false
    }
  },
  async mounted() {
    setTimeout(function() {
      pdfMake.fonts = {
        Arial: {
          normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
          bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
        }
      }
    }, 1000);
    // init signature pad
    // let externalScript = document.createElement('script')
    // externalScript.setAttribute('src', '/static/js/plugins/signaturePad/signature_pad.umd.js')
    // document.head.appendChild(externalScript)
    var canvas = document.getElementById('signin-signature-pad')
    this.signaturePad = new SignaturePad(canvas, {
      backgroundColor: 'rgb(255, 255, 255)'
    })
    if (this.$route.params.pairingID) {
      await this.$store.dispatch('pairing/getPairingDetails', this.$route.params.pairingID)
      if (!this.pairingDetails.id) {
        window.location.replace('/')
      }
      if (this.pairingDetails.signinForm) {
        this.$swal({
          text: 'This endorsement form is completed.',
          type: 'warning',
          confirmButtonText: 'OK',
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            window.location.replace('/')
          }
        })
      }
      if (this.pairingDetails.campaignID) {
        this.campaign = await campaignAPIs.getCampaignDetailForFeedback(this.pairingDetails.campaignID)
        let infDetails = this.pairingDetails.influencer_details
        this.displayData = Object.assign({}, {
          handle: infDetails.instagramHandle,
          platform: infDetails.platform,
          platformName: infDetails.platformName || 'Platform',
          campaignID: this.campaign.id,
          campaignName: this.campaign.name,
          clientName: this.campaign.client ? this.campaign.client.name : '-'
        })
        if (infDetails.platform && infDetails.platform === 'xiaohongshu') {
          this.displayData.handle = infDetails.fullName
        }
      }
    }
  }
}
</script>
<style scoped>
  .v-card {
    background-color: rgb(204, 204, 204)!important;
  }

  .content {
    max-width: 100%!important;
    background-color: #fff;
    padding: 50px;
  }

  .avatar-logo {
    width: 120px!important;
    min-width: 120px!important;
    margin: 0 auto;
    height: auto!important;
    line-height: 0;
  }

  .avatar-logo img {
    display: block;
    width: 100%;
    height: auto;
  }

  .default-title {
    font-size: 18px;
  }

  .address-title {
    line-height: 1.8rem;
    font-size: 18px;
  }

  .brand-secondary-bg {
    background-color: var(--v-theme-secondary, #3F3FFF);
    border-bottom: 1px solid black;
    padding: 5px;
    color: white;
  }

  .brand-secondary-total-cell {
    background-color: var(--v-theme-secondary, #3F3FFF);
    text-align: center;
    color: white;
    border-left: 1px solid black;
  }

  @media (max-width: 768px) {
    .content {
      padding: 20px;
    }
  }
  tr td {
    padding: 5px !important;
  }
  td {
    border-bottom: 1px solid black;
    border-right: 1px solid black;
  }
  li {
    list-style: decimal;
  }
</style>



// WEBPACK FOOTER //
// Form.vue?b9a296fc